// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogClose, DialogContent, DialogTitle, Icon, } from '@a-type/ui';
import { graphql, useQuery } from '@biscuits/graphql';
import { proxy, useSnapshot } from 'valtio';
import { LoginButton } from './LoginButton.js';
import { Price } from './Price.js';
const subscriptionPromotionState = proxy({
    status: 'closed',
    title: 'Upgrade for sync & more',
    description: '',
});
export function showSubscriptionPromotion(title = 'Upgrade for sync & more', description = '') {
    subscriptionPromotionState.status = 'open';
    subscriptionPromotionState.title = title;
    subscriptionPromotionState.description = description;
}
const promotionProductQuery = graphql(`
	query PromotionProduct {
		productInfo(lookupKey: "for_one") {
			id
			price
			currency
			period
		}
	}
`);
export function SubscriptionPromotion({ children, }) {
    const { status, title, description } = useSnapshot(subscriptionPromotionState);
    const { data } = useQuery(promotionProductQuery);
    const price = data === null || data === void 0 ? void 0 : data.productInfo.price;
    const currency = data === null || data === void 0 ? void 0 : data.productInfo.currency;
    const period = data === null || data === void 0 ? void 0 : data.productInfo.period;
    return (_jsx(Dialog, { open: status !== 'closed', onOpenChange: (open) => {
            if (!open) {
                subscriptionPromotionState.status = 'closed';
            }
        }, children: _jsxs(DialogContent, { width: "lg", children: [_jsxs("div", { className: "flex flex-row items-start gap-2", children: [_jsx(DialogTitle, { className: "flex-1", children: title }), _jsx(DialogClose, { asChild: true, children: _jsx(Button, { size: "small", color: "ghost", children: _jsx(Icon, { name: "x" }) }) })] }), description && _jsx(Dialog.Description, { children: description }), children, _jsx(DialogActions, { children: _jsxs("div", { className: "flex flex-col gap-2 items-center m-auto mt-1", children: [_jsx(LoginButton, { color: "primary", returnTo: "/", onClick: () => (subscriptionPromotionState.status = 'closed'), children: "Join the club" }), _jsxs("span", { className: "text-xs", children: ["Starting at", ' ', _jsx(Price, { value: price, currency: currency, period: period }), ". 14 days free."] })] }) })] }) }));
}
//# sourceMappingURL=SubscriptionPromotion.js.map